import { render, staticRenderFns } from "./userPermissionType.vue?vue&type=template&id=39f114e2&scoped=true&"
import script from "./userPermissionType.vue?vue&type=script&lang=js&"
export * from "./userPermissionType.vue?vue&type=script&lang=js&"
import style0 from "./userPermissionType.vue?vue&type=style&index=0&id=39f114e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f114e2",
  null
  
)

export default component.exports